import {sum, values, map, mapValues, at} from 'lodash/fp'
import React, {Component} from 'react'

import {countriesById} from '../../data/countries'
import {avgCo2, categories, categoryMeta} from '../../data/categories'
import Button from '../../components/Button'
import PieChart from '../../components/PieChart'

import './styles.css'

class Results extends Component {
  state = {
    selected: {},
  }

  onSelected = data => this.setState({selected: data})

  render() {
    const {emissions, onAcknowledge, onJointAcknowledge, onReviseAnswers, onReviseCountry, showJoint, country} = this.props
    const {selected} = this.state
    const usa = country === 'US'
    const co2 = usa ? sum(values(emissions)) : countriesById[country].co2
    const ratio = usa ? (co2 / avgCo2).toFixed(1) : 0
    const co2ByCategory = usa ? mapValues(category => sum(at(category, emissions)), categories) : []
    const data = usa ? map(category => ({...category, value: co2ByCategory[category.id]}), categoryMeta) : []
    const dimension = window.outerHeight < 600 ? 175 : 200

    return (
      <div className="results">
        {usa && <div className="results-compare">Your total score is {ratio}x the national average</div>}
        <div className="results-value">{co2 >= 100 ? co2.toFixed(0) : co2.toFixed(1)}</div>
        <div className="results-label">Tonnes Climate Pollution (CO2E)</div>
        {usa && <PieChart data={data} width={dimension} height={dimension} selected={selected} onSelected={this.onSelected} />}
        {usa && selected.id && 
          <div className="results-chosen">
            {selected.display}:  {selected.value.toFixed(1)} tonnes CO2e
          </div>
        }
        {usa &&
          <div className="results-caption" onClick={onReviseAnswers}>
            <i className="fa fa-angle-double-left" /> Revise Answers
          </div>
        }
        {!usa &&
          <div className="results-caption" onClick={onReviseCountry}>
            <i className="fa fa-angle-double-left" /> Revise Country
          </div>
        }
      </div>
    )
  }
}

export default Results



// WEBPACK FOOTER //
// ./src/apps/Results/index.js